import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import { IGetServiceProps } from "@api/types/globalService.types";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";

export const useGetAllGadgetService = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allGadgetsService = useQuery({
    queryKey: [...CACHE_KEYS.GADGETS, page, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.GADGETS,
        searchParams: {
          page,
          "filter[name]": debouncedQuery,
          per_page,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allGadgetsService },
    states: { searchQuery, setSearchQuery },
  };
};
